import triggerConversionEvent from "./triggerConversionEvent";
import {
  createEnrollment,
  silentCreateEnrollment,
} from "@/lib/partner-api/createEnrollment";
import getTrackSelectionUrl from "./getTrackSelectionUrl";
import resolveEnrollmentRedirectUrl from "./resolveEnrollmentRedirectUrl";
import { EnrollHandlerProps } from "../types";
import { getAnonymousId } from "@/utils/tagular/helpers";
import { appendMarketplaceAttributionParamsToHref } from "@/utils/functions/marketplaceAttribution";
import { resolveClientMarketplaceAttribution } from "@/utils/functions/marketplaceAttributionSession";

const enroll = async ({
  courseRun,
  course,
  type,
  opts,
  useNewTrackSelect,
  category,
  courseSlug,
  isUserEntitled,
  emailOptIn,
  commerceCoordinatorUrl,
  authBaseUrl,
  isLoggedIn,
  byPassAuth = false,
}: EnrollHandlerProps) => {
  try {
    if (Boolean(useNewTrackSelect)) {
      const anonymousId = getAnonymousId();
      await silentCreateEnrollment({
        courseId: courseRun.key,
        emailOptIn,
        anonymousId: anonymousId,
      });
      if (typeof window !== "undefined" && window.newrelic) {
        window.newrelic.addPageAction("CourseEnroll.silentEnrollmentCreated", {
          courseId: courseRun.key,
          anonymousId: anonymousId,
        });
      }
    } else {
      await createEnrollment({
        courseId: courseRun.key,
        emailOptIn,
      });

      if (typeof window !== "undefined" && window.newrelic) {
        window.newrelic.addPageAction("CourseEnroll.enrollmentCreated", {
          courseId: courseRun.key,
        });
      }
    }

    triggerConversionEvent({
      course,
      isUserEntitled,
      courseRun,
      customName: type,
    })();
  } catch (error) {
    //TODO: There is specific error handling for 403, where the users get redirected to user_message_url in the error message
    //Otherwise normal redirect applies
  } finally {
    const trackUrl = resolveEnrollmentRedirectUrl({
      directToPayment: Boolean(opts?.directToPayment),
      straightToCheckout: Boolean(opts?.straightToCheckout),
      commerceCoordinatorUrl,
      getTrackSelectionFallback: () =>
        getTrackSelectionUrl({
          courseRunKey: courseRun.key,
          category,
          courseSlug,
          useNewTrackSelect: Boolean(useNewTrackSelect),
          emailOptIn,
          authBaseUrl,
          isUserLoggedIn: isLoggedIn,
          byPassAuth,
        }),
    });
    const attributedTrackUrl = appendMarketplaceAttributionParamsToHref({
      href: trackUrl,
      source: resolveClientMarketplaceAttribution(window.location.search),
      includeNextDestination: true,
    });
    if (typeof window !== "undefined" && window.newrelic) {
      window.newrelic.addPageAction("CourseEnroll.redirectToTrack", {
        trackUrl: attributedTrackUrl,
      });
    }
    //Redirects to track in all cases
    window.location.href = attributedTrackUrl;
  }
};

export default enroll;
